// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import {Text} from '../../comp/text';
import {Icon} from '../../comp/icon';
import {TH, TR, TD, Table} from '../../comp/table';
import {fmt_money} from '../../utils/misc.js';
import * as cns from './table_bvpn.module.less';

const get_accepted_icon = ref=>{
    const {ico, color, tip} = {
        ip_invalid: {
            color: 'error',
            ico: 'close',
            tip: <span>These referrals are invalid because the IP address they
              were installed on is already on the Bright Data network or has a
              datacenter/bad reputation address</span>,
        },
    }[ref.accepted===false ? 'ip_invalid' : '']
        || {color: 'success', ico: 'success', tip: null};
    return <Icon tip={tip} tip_placement="top" ico={ico} color={color}/>;
};

const get_bounty_maxed_icon = ref=>
    ref.bounty_maxed ? <Icon ico="success" color="success"/> : '';

function Table_header(){
    return <>
      <TH left>Num</TH>
      <TH left>Device</TH>
      <TH>Accepted</TH>
      <TH>Redeemed</TH>
      <TH>Earned</TH>
    </>;
}

function Row({data: i}){
    return <TR className={cns.row}>
      <TD left>
        <Text.s no_wrap>{i.id}</Text.s>
      </TD>
      <TD left>
        <Text.s mono no_wrap>{i.uuid}</Text.s>
      </TD>
      <TD>{get_accepted_icon(i)}</TD>
      <TD>{get_bounty_maxed_icon(i)}</TD>
      <TD>
        <Text.s mono no_wrap>{fmt_money(i.bounty, 3)}</Text.s>
      </TD>
    </TR>;
}

const render_row = t=><Row key={t.uuid} data={t}/>;

export function Referees_bvpn_table({list, loading, pagination, className}){
    return <div className={cn(cns.root, className)}>
      <Table header={<Table_header/>} list={list} loading={loading}
        render_row={render_row} id_key="id" pagination={pagination}/>
    </div>;
}
